<template>
  <vinnuskoli-page>
    <b-row class="mb-3">
      <b-col>
        <div class="page-title mb-0">Fjarvistartegundir</div>
      </b-col>
      <b-col class="d-flex justify-content-end" v-if="loggedInUserHasAnyPermission('write_attendancetype')">
        <b-btn variant="primary" @click.prevent="absenceCreateModal" class="pull-right">
          <i class="fa fa-fw fa-plus-circle"></i>
          Bæta við
        </b-btn>
      </b-col>
    </b-row>
    <b-card no-body border-variant="light" class="mb-2">
      <table class="table mb-0">
        <thead>
          <tr class="bg-gray-200 small">
            <th>Heiti</th>
            <th>Sýnileg á umsóknarvef</th>
            <th>Veikindategund</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <td colspan="100"><loading /></td>
        </tbody>
        <tbody v-if="absenceList.length == 0 && !loading">
          <td colspan="100"><i>Engar leitarniðurstöður fundust.</i></td>
        </tbody>
        <tbody v-if="!loading && absenceList.length > 0">
          <tr v-for="absence in absenceList" :key="absence.id">
            <td>{{ absence.name }}</td>
            <td><span v-if="absence.is_public">Já</span><span v-else>Nei</span></td>
            <td><span v-if="absence.is_sick_type">Já</span><span v-else>Nei</span></td>
            <td class="text-right">
              <b-btn
                :size="'sm'"
                variant="primary"
                @click.prevent="absenceEditModal(absence.id)"
                v-if="loggedInUserHasAnyPermission('write_attendancetype')"
              >
                <i class="fa fa-fw fa-pencil"></i>
              </b-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <absence-create-modal ref="absenceCreateModal" @successful="loadList"></absence-create-modal>
    <absence-create-modal ref="absenceEditModal" @successful="loadList"></absence-create-modal>
  </vinnuskoli-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import attendance from '@/api/attendance';
import absenceCreateModal from '@/components/absence/AbsenceCreateModal.vue';

export default {
  name: 'absence',
  components: {
    absenceCreateModal,
  },
  computed: {
    ...mapGetters(['loggedInUserHasAnyPermission', 'loggedInUserOptions']),
  },
  data() {
    return {
      absenceList: [],
      loading: false,
    };
  },
  methods: {
    async loadList() {
      this.loading = true;
      this.absenceList = [];
      try {
        const response = await attendance.attendanceTypeList();
        this.absenceList = response.data;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    /*
     * Modal gluggar
     */
    absenceCreateModal() {
      this.$refs.absenceCreateModal.show();
    },
    absenceEditModal(id) {
      this.$refs.absenceEditModal.show(id);
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadList();
  },
};
</script>

<style></style>
